var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCube = function SvgCube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.209 13.605V6.401a1.8 1.8 0 0 0-.9-1.558l-6.304-3.602a1.8 1.8 0 0 0-1.801 0L1.9 4.843A1.8 1.8 0 0 0 1 6.401v7.204a1.8 1.8 0 0 0 .9 1.558l6.304 3.602a1.8 1.8 0 0 0 1.801 0l6.304-3.602a1.8 1.8 0 0 0 .9-1.558"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.242 5.465 7.861 4.548 7.861-4.548M9.104 19.08v-9.077"
  }))));
};
export default SvgCube;